module.exports = __webpack_public_path__ + "media/images/emblems/Uetikon-blazon-7e9411da685595104c35b40e2f87e0ce.svg";